import { useEffect, useState } from 'react'

const useHasWindow = () => {
  const [isWindow, setIsWindow] = useState(false)

  useEffect(() => {
    setIsWindow(true)

    return () => setIsWindow(false)
  }, [])

  return isWindow
}

export default useHasWindow
